import {
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { UploadWizardService } from '../wizard.service';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'upload-wizard-sticker-density',
  templateUrl: './stickerDensity.component.html',
  styleUrls: ['../wizard.component.scss', './stickerDensity.component.scss'
  , '../bookformatDensity/bookformatDensity.component.scss']
})
export class UploadWizardStickerDensityComponent {

  @Input() step;
  @Input() totalSteps;
  @Input() isMobile;
  @Input() projectId;
  @Input() isProjectUpdating;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();

  tsfLabels = ['Never', 'Sometimes', 'Often'];

  constructor(
    public uploadWizardService: UploadWizardService,
    public translate: TranslateService,
    private firebaseService: FirebaseService,
  ) {}

  getStickerDensityName(index) {
    const stickerDensity = this.uploadWizardService.stickerDensities[index];
    return stickerDensity.name;
  }

  get stickerDensitySelected() {
    return this.uploadWizardService.stickerDensities.findIndex(
      stickerDensity => stickerDensity.slug === this.uploadWizardService.specs.text_sticker_level
    );
  }

  isStickerDensitySelected(index) {
    return this.stickerDensitySelected === index;
  }

  get stickerDensityPicUrl() {
    return this.uploadWizardService.stickerDensities[this.stickerDensitySelected].picture_url;
  }

  public selectStickerDensity(index) {
    const stickerDensity = this.uploadWizardService.stickerDensities[index];
    this.uploadWizardService.specs.text_sticker_level = stickerDensity.slug;
    this.firebaseService.logEvent('design_request_text_sticker_level_select', {
      project_id: this.projectId,
      sticker_level: this.uploadWizardService.specs.text_sticker_level
    });
  }

  submit() {
    this.next.emit();
  }
}
